import type React from "react";

export function DividerLineIcon(): React.ReactNode {
  return (
    <span style={{ padding: "0 5px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2.5"
        height="20"
        viewBox="0 0 1.5 15"
      >
        <title>Divider Line</title>
        <line
          id="Line_214"
          data-name="Line 214"
          y2="22.281"
          transform="translate(0.75)"
          fill="none"
          stroke="#000"
        />
      </svg>
    </span>
  );
}
